export const USER = '/user';
export const IS_AUTH = '/user/is-auth';
